import React from 'react';
import './GurapalabQuote.css';

export default function GurapalabQuote() {
  return (
    <div className="gurapalab-quote-container">
      <h1>구라파랩 개발 기획서</h1>
      <section>
        <h2>1. 프로젝트 개요</h2>
        <ul>
          <li><strong>목적:</strong>
            <ul>
              <li>온라인: 이탈리아·프랑스 등 유럽 혹은 해외 브랜드의 국내 판매를 구라파랩 자체 플랫폼과 AI 오토메이션으로 수행</li>
              <li>오프라인: 폐교·폐건물 재생 프로젝트에 AI 기반 설계·운영 기술을 적용해 지역 거점 공간으로 전환</li>
            </ul>
          </li>
          <li><strong>비전:</strong> “AI Native Lifestyle Hub” – 유통·공간·콘텐츠를 AI로 연결하여 효율성·확장성을 극대화</li>
          <li><strong>핵심 지표 예시:</strong> 월간 취급 브랜드 수, 자동 생성 상품 페이지 수, 당일 가격 동기화 비율, 설계안 승인 TAT(Time-to-Approve) 등</li>
        </ul>
      </section>
      <section>
        <h2>2. 전략적 목표</h2>
        <h3>2-1. 온라인 플랫폼</h3>
        <ul>
          <li>중간 유통(Shopify 등) 무탈피 → 구라파랩 독자 플랫폼</li>
          <li>AI 자동화로 SKU 확보→상세페이지→재고/가격→CS까지 E2E 처리</li>
          <li>롱테일 상품을 빠르게 온보딩해 국내 소비자에게 “희소성 + 합리적 가격” 제공</li>
        </ul>
        <h3>2-2. 오프라인 재생</h3>
        <ul>
          <li>폐교·폐건물을 <strong>AI Generative Design + VR Digital Twin</strong>으로 리모델링</li>
          <li>지역 문화를 반영한 테마 공간(쇼룸·팝업·체험관)으로 전환</li>
          <li>설계→시공→운영 전 과정 데이터를 축적해 차기 프로젝트의 레퍼런스 & SaaS 모듈화</li>
        </ul>
      </section>
      <section>
        <h2>3. 공통 개발 원칙</h2>
        <ul>
          <li>AI-Native (모든 핵심 프로세스를 ML/LLM 퍼스트로 설계)</li>
          <li>모듈화 / API-First (온라인·오프라인 공통 엔진 재사용)</li>
          <li>서버리스·컨테이너 혼용으로 스케일-투-제로 비용 최적화</li>
          <li>데이터 거버넌스(개인 식별 정보 보호, GDPR/한국 개인정보 보호법 준수)</li>
          <li>단계별 MVP → Pilot → Full-Scale 전개</li>
        </ul>
      </section>
      <section>
        <h2>4. 온라인 플랫폼 세부 기획</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Phase</th><th>기간(예시)</th><th>핵심 목표</th><th>주요 기능·AI 모듈</th><th>팀 구성 / 주요 산출물</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Phase 1 – Foundation</strong><br />(M0-M4)</td>
                <td>브랜드 1-3개, SKU ≤100</td>
                <td>브랜드·상품 메타데이터 스키마 정의<br />다국어 LLM 번역·카테고리 매핑 MVP</td>
                <td>Brand Crawler Bot, Product ETL Pipeline, Image Enhancer</td>
                <td>PM 1, Backend 2, ML 1, FE 1<br />API 명세서, DWH ERD, Admin MVP</td>
              </tr>
              <tr>
                <td><strong>Phase 2 – Automation Scale-up</strong><br />(M4-M8)</td>
                <td>브랜드 ~10개, SKU ≤1,000</td>
                <td>상세페이지 자동 생성률 ≥ 85%<br />재고·가격 실시간 Sync (15분)</td>
                <td>LLM-PageBuilder, Pricing Agent, Inventory Watcher</td>
                <td>추가 ML Engineer 1, DevOps 1<br />템플릿 라이브러리, 알림 Slack Bot, CS 대시보드</td>
              </tr>
              <tr>
                <td><strong>Phase 3 – Ecosystem & Intelligence</strong><br />(M8-M12)</td>
                <td>SKU ≥10,000</td>
                <td>AI 추천·검색 Precision ≥ 0.9<br />반품-문의 자동 처리율 ≥ 70%</td>
                <td>Vector Search + RAG FAQ Bot, Demand Forecast Model, Partner Portal</td>
                <td>Data Sci 1, Partnership PM 1<br />AI 트레이닝 파이프라인, BI Cockpit, OKR 리포트</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="tech-stack"><strong>기술 스택 예시:</strong> Backend: Python(FastAPI), Node.js(BFF); ML: OpenAI GPT-4o / Llama 3 FT; Data: PostgreSQL, Snowflake; Infra: AWS EKS; Front: Next.js</p>
      </section>

      <section>
        <h2>4-1. 온라인 플랫폼 Phase 1 상세</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>구분</th><th>무엇을 개발하나요?</th><th>가능해지는 일</th><th>실제 활용 시나리오</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>A. Brand Crawler Bot</strong></td>
                <td>- 브랜드 1-3곳의 CSV/API/웹 주 1회 크롤링<br />- 상품 메타·이미지 자동 수집</td>
                <td>신상품 등록 시 <strong>24시간</strong> 내 ‘검수 대기’ 표시</td>
                <td>브랜드 A가 CSV 업로드 → 30분 후 Admin에 SKU 18개 자동 등록</td>
              </tr>
              <tr>
                <td><strong>B. Product ETL Pipeline</strong></td>
                <td>- 필드 통합·중복 제거·카테고리 매핑(네이버·쿠팡 기준)<br />- 품절·단종 SKU 자동 비활성화</td>
                <td>“가격 0원·사진 누락” 오류 상품 즉시 차단</td>
                <td>운영자가 오류 알림 클릭 → 잘못된 SKU 2건 한 번에 수정</td>
              </tr>
              <tr>
                <td><strong>C. LLM 번역·스타일 매퍼</strong></td>
                <td>- GPT-4o로 제품명·설명을 한/영 동시 번역<br />- 구라파랩 톤&매너 자동 교정</td>
                <td>수입 브랜드 특유 표현을 <strong>적합 문구</strong>로 변환</td>
                <td><em>Vitello pieno fiore</em> → 프리미엄 풀그레인 소가죽</td>
              </tr>
              <tr>
                <td><strong>D. Admin Mini Dashboard</strong></td>
                <td>- 모바일 대응 UI / 승인·보류·삭제 버튼 제공</td>
                <td>밤 11시에도 휴대폰에서 SKU 승인 가능</td>
                <td>주말 긴급 수정 요청 → 5분 내 반영</td>
              </tr>
              <tr>
                <td><strong>E. Image Enhancer</strong></td>
                <td>- 800px 미만 이미지 → 1,600px 업스케일<br />- 배경 통일·그림자 합성</td>
                <td>통일된 브랜드 썸네일 생성</td>
                <td>해외 촬영본 배경 제거 → ‘구라파랩 스타일’ 썸네일</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="tech-stack"><strong>핵심 가치</strong><br />
• 100 SKU 수작업 2.5영업일 → AI 2시간<br />• 운영 인력 1명 + ML 1명으로 초기 카탈로그 안정 관리<br />• Phase 2 자동화 학습용 데이터 축적
</p>
      </section>


      <section>
        <h2>5. 오프라인 재생 세부 기획</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Phase</th><th>기간(예시)</th><th>핵심 목표</th><th>주요 기능·AI 모듈</th><th>팀 구성 / 주요 산출물</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Phase 1 – Digital Twin</strong><br />(M0-M4)</td>
                <td>대상 부지 ~2곳 스캔</td>
                <td>LiDAR/Drone 스캔 → BIM 모델화<br />구조 안전 검토</td>
                <td>Site Scanner Pipeline, Feasibility AI Analyst</td>
                <td>Archi-PM 1, GIS Engineer 1, ML 1<br />BIM 파일, ROI 시뮬레이션</td>
              </tr>
              <tr>
                <td><strong>Phase 2 – Generative Design</strong><br />(M4-M10)</td>
                <td>1:50 디자인안 승인</td>
                <td>AI 시나리오별 레이아웃 5안<br />VR 투어 MVP</td>
                <td>Generative Layout Engine, VR Digital Twin</td>
                <td>3D Dev 2, UX Designer 1, ML 1<br />디자인 Option Book, VR Demo</td>
              </tr>
              <tr>
                <td><strong>Phase 3 – Smart Ops</strong><br />(M10-M18)</td>
                <td>준공 이후 6개월 운영</td>
                <td>에너지 ↓10%<br />방문자 체류 ↑20%</td>
                <td>Building AI-Ops, Community App</td>
                <td>IoT Engineer 1, Mobile Dev 1, Data Ops 1<br />KPI 대시보드, 운영 Playbook</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="tech-stack"><strong>기술 스택 예시:</strong> 3D & BIM: Autodesk Forge; Generative Design: Rhino3D; VR/AR: Unity; IoT: AWS IoT Core</p>
      </section>

      <section>
        <h2>5-1. 오프라인 재생 Phase 1 상세</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>구분</th>
                <th>무엇을 개발하나요?</th>
                <th>가능해지는 일</th>
                <th>실제 활용 시나리오</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>A. LiDAR·Drone Scan Pipeline</strong></td>
                <td>- 부지 2곳 3D 스캔<br />- Point Cloud → BIM 자동 변환 (IFC)</td>
                <td>실측 없이 ±2cm 정확도 모델 확보</td>
                <td>스캔 하루 만에 교실·체육관 치수 자동 추출</td>
              </tr>
              <tr>
                <td><strong>B. Feasibility AI Analyst</strong></td>
                <td>- 인구·교통·관광 데이터 수집·시각화<br />- 예상 방문·매출·CO₂ 절감 시뮬레이션</td>
                <td>투자·지자체에 “BEP 4.8년” 등 수치 즉시 제시</td>
                <td>PT 중 PDF 클릭 → 보고서 다운로드</td>
              </tr>
              <tr>
                <td><strong>C. Web BIM Viewer</strong></td>
                <td>- 브라우저에서 3D 모델 회전·단면 보기<br />- 코멘트·TODO 기능</td>
                <td>원격 실시간 협업 지원</td>
                <td>서울 본사·현장소장·프랑스 파트너 동일 화면 공유</td>
              </tr>
              <tr>
                <td><strong>D. 리스크·ROI 패널</strong></td>
                <td>- 초기 CAPEX vs 예상 매출·운영비 비교<br />- 법규·내진 체크리스트 자동 스코어링</td>
                <td>“내진 보강 ★★★” 경고 → 즉시 설계 변경</td>
                <td>내진 비용 1.5억 → 대안 자재 제안 9천만으로 절감</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="tech-stack">
          <strong>핵심 가치</strong><br />
          • 전통 실측·2D CAD 4주 → <strong>3일</strong> 내 Digital Twin 완성<br />
          • ROI·리스크 수치 제시로 투자 협상 시간 <strong>60% 단축</strong><br />
          • Phase 2 ‘AI 설계·VR’ 기반 데이터셋 확보
        </p>
      </section>



      <section>
        <h2>6. 통합 로드맵(요약)</h2>
        <ul>
          <li>M0–M4: Data Lake 설계 → 온라인/오프라인 Phase1 동시 착수</li>
          <li>M4–M10: 온라인 Phase2 ↔ 오프라인 Phase2 리소스 공유</li>
          <li>M10–M18: 공통 AI-Ops 플랫폼 완성 → Joint Launch</li>
          <li>M18+: 해외 지사/파이낸싱 확대 → 다국가 Hub 검토</li>
        </ul>
      </section>
      <section>
        <h2>7. 리스크 및 대응</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr><th>리스크</th><th>영향</th><th>대응 방안</th></tr>
            </thead>
            <tbody>
              <tr><td>브랜드 데이터 포맷 다양성</td><td>ETL 오류·지연</td><td>Parser 모듈화, 예외 로그 자동 학습</td></tr>
              <tr><td>환율·관세 변동성</td><td>가격 경쟁력 저하</td><td>Pricing Agent에 실시간 환율 API + 헤징 시뮬레이션</td></tr>
              <tr><td>폐건물 법규 이슈</td><td>일정 지연</td><td>지방자치단체 협업 MOU</td></tr>
              <tr><td>LLM Hallucination</td><td>상품 정보 오류</td><td>RAG + Ground-Truth DB, Human-in-the-Loop</td></tr>
              <tr><td>AI 윤리·GDPR</td><td>법적 리스크</td><td>데이터 익명화, DSAR 워크플로 구축</td></tr>
            </tbody>
          </table>
        </div>
      </section>
      <section>
        <h2>8. 기대효과 (Phase 1 완료 기준)</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>지표</th><th>현재(수작업·전통 방식)</th><th>AI 도입 후</th><th>개선 폭</th><th>근거·가정</th>
              </tr>
            </thead>
            <tbody>
              <tr><td><strong>상품 온보딩 속도</strong></td><td>1인당 하루 20-50 SKU</td><td>하루 250 SKU (AI 240 + 검수 10)</td><td>~12.5배↑</td><td>입력·번역·보정 15min → AI 1min</td></tr>
              <tr><td><strong>상세페이지 제작비</strong></td><td>30,000원/SKU</td><td>9,000원/SKU</td><td>70%↓</td><td>100 SKU → 210만 절감</td></tr>
              <tr><td><strong>가격·재고 정확도</strong></td><td>품절 주문률 3%</td><td>0.3%</td><td>-90%</td><td>15min Sync</td></tr>
              <tr><td><strong>Digital Twin 제작기간</strong></td><td>건물 1동 4주</td><td>3일</td><td>90% 단축</td><td>스캔·BIM 자동화</td></tr>
              <tr><td><strong>측량·설계 초기비</strong></td><td> - </td><td> - </td><td> - </td><td> - </td></tr>
              <tr><td><strong>데이터·레퍼런스 자산</strong></td><td>없음</td><td>100 SKU 메타·BIM 2건<br />로그 1만 건</td><td>- SaaS 파일럿 1건 (월 300만)</td><td>중소 유통사 API 제공</td></tr>
            </tbody>
          </table>
        </div>
        <p className="tech-stack"><strong>요약 효과</strong><br />
① 운영·제작 비용 절감<br />
② 타당성 분석 및 초기 비용 절감<br />
③ SaaS 파일럿 매출 기대 효과
</p>
      </section>
      <section>
        <h2>9. 향후 과제 · 예산 프레임</h2>
        <ul>
          <li>Phase별 인원·기간 산출</li>
          <li>API vs On-Prem 비용 비교</li>
        </ul>
      </section>

      <section>
        <h2>10. 지식재산권</h2>
        <p>
          지식재산권 귀속: 본 프로젝트를 통해 완성된 결과물(제품 정보 DB, 관리자 대시보드, 사용자 UI 등)은 구라파랩에 귀속되며, 단, 본 용역 과정에서 활용되거나 개발된 AI 모델 연동 아키텍처, 자체 LLM API 처리 방식(A2A 연동 등)과 같은 범용 기술 및 모듈은 아케인즈의 고유 기술로서 해당 기술에 대한 소유권과 지식재산권은 아케인즈에 귀속되어 있습니다. (범용 기술은 MIT License와 같은 오픈소스 라이센스에 따라 적용됩니다.)
        </p>
      </section>
    </div>
  );
}